import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueSentry } from '@sentry/integrations';
import filters from './filters';
import lazyLoad from './lazy-load';
import markdown from './markdown';
import sound from './sound';
import timeAgo from './time-ago';

const { VUE_APP_SENTRY_DSN } = process.env;
const VueInstance: any = Vue;
VueInstance.config.productionTip = false;

filters(VueInstance);
lazyLoad(VueInstance);
markdown(VueInstance);
sound(VueInstance);
timeAgo(VueInstance);

VUE_APP_SENTRY_DSN && Sentry.init({
  dsn: VUE_APP_SENTRY_DSN,
  integrations: [
    new VueSentry({
      Vue,
      attachProps: true,
    }),
  ],
});

export default VueInstance;
